import helpers from "../utils/helpers";

window.recaptchaCompareOnloadCallback = function () {
  grecaptcha.render("recaptcha_element", {
    sitekey: recaptcha_key,
    size: "invisible",
    badge: "inline",
    callback: templateCompare.challange,
  });
};

var compare_form = $("#contact-form");
const templateCompare = {
  init: function () {
    if (compare_form.length) {
      compare_form.on("submit", function (e) {
        e.preventDefault();
        $(".error", this).removeClass("error");
        if (helpers.validate($(this))) {
          window.grecaptcha.execute();
        }
      });
    }

    $(".compare__gallery__view").click(function () {
      $(this).prev().find(".gallery__item:first").click();
    });
  },

  challange: function (token) {
    if (token) {
      templateCompare.submit(token);
    }
    window.grecaptcha.reset();
  },

  submit: function (token) {
    var form_data = {
      name: compare_form.find("#name").val(),
      surname: compare_form.find("#surname").val(),
      phone: compare_form.find("#phone").val(),
      email: compare_form.find("#email").val(),
      area: compare_form.find("#area").val(),
      tmwidth: compare_form.find("#tmwidth").val(),
      concrete: compare_form.find("#concrete").val(),
      hydro: compare_form.find('[name="hydro"]:checked').val(),
      incrop: compare_form.find('[name="incrop"]:checked').val(),
      message: compare_form.find("#message").val(),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_compare",
        form_data: form_data,
        post_id: compare_form.find("#post-id").val(),
        compare_token: token,
        compare_nonce: compare_form.find("#compare-nonce").val(),
        compare_honey: compare_form.find("#compare-honey").val(),
      },
      beforeSend: function () {
        compare_form.addClass("loading");
        compare_form.find("button").addClass("loading");
        compare_form.find(".form__status").addClass("hidden");
      },
      success: function (response) {
        compare_form.removeClass("loading");
        compare_form.find("button").removeClass("loading");
        if (response.success) {
          compare_form.find(".errors-wrap").remove();
          compare_form
            .find(".form__status")
            .removeClass("error")
            .text(response.data.message)
            .removeClass("hidden");
          compare_form[0].reset();
          grecaptcha.reset();
          compare_form.find("input, textarea").blur();
        } else {
          compare_form
            .find(".form__status")
            .addClass("error")
            .text(response.data.message)
            .removeClass("hidden");
        }
      },
    });
  },
};

export default templateCompare;
